<template>
  <div v-if="show" class="modal-backdrop fade show"></div>
  <div v-if="show && facture" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content shadow-lg border-0 rounded-4">
        <div class="modal-header bg-dark text-white p-4 border-0">
          <div class="d-flex align-items-center gap-3">
            <div class="icon-circle bg-primary bg-opacity-20 text-primary p-3 rounded-circle">
              <i class="fas fa-file-invoice fs-4 text-white"></i>
            </div>
            <div>
              <h5 class="modal-title fw-bold mb-0">Facture d'Achat : {{ facture.numeroEntree }}</h5>
              <p class="text-white-50 small mb-0">Réf. Fournisseur: {{ facture.numeroFactureFournisseur }}</p>
            </div>
          </div>
          <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
        </div>

        <div class="modal-body p-4 bg-light" id="printableInvoice">
          <div class="card border-0 shadow-sm p-4 mb-4 rounded-3 bg-white">
            <div class="d-flex justify-content-between align-items-start pb-3 border-bottom mb-3">
              <div>
                <span class="badge bg-success bg-opacity-10 text-success fw-bold px-3 py-2 rounded-pill mb-2">
                  <i class="fas fa-check-circle me-1"></i>Facture {{ facture.statut }}
                </span>
                <h3 class="fw-bold text-dark mb-1">{{ facture.fournisseur }}</h3>
                <p class="text-muted small mb-0" v-if="facture.matriculeFiscal">Matricule Fiscal: {{ facture.matriculeFiscal }}</p>
              </div>

              <div class="text-end">
                <div class="text-muted small">Code Entrée Stock</div>
                <div class="fs-5 fw-bold text-primary">{{ facture.numeroEntree }}</div>
              </div>
            </div>

            <div class="row g-3">
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <span class="text-muted small d-block">N° Facture Fournisseur</span>
                  <strong class="text-dark">{{ facture.numeroFactureFournisseur }}</strong>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <span class="text-muted small d-block">Date Facture</span>
                  <strong class="text-dark">{{ formatDate(facture.dateFacture) }}</strong>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <span class="text-muted small d-block">Mode de Paiement</span>
                  <strong class="text-dark text-capitalize">{{ facture.modePaiement }}</strong>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <span class="text-muted small d-block">Date d'Échéance</span>
                  <strong class="text-dark">{{ formatDate(facture.dateEcheance) || 'Non spécifiée' }}</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="card border-0 shadow-sm p-4 rounded-3 bg-white mb-4">
            <h6 class="fw-bold mb-3 text-dark"><i class="fas fa-boxes me-2 text-success"></i>Lignes de Produits Réceptionnées</h6>
            <div class="table-responsive">
              <table class="table table-bordered align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Désignation</th>
                    <th>Catégorie</th>
                    <th class="text-center">Qté</th>
                    <th class="text-end">P.U HT</th>
                    <th class="text-center">TVA</th>
                    <th class="text-end">Total TTC</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(l, i) in facture.lignes" :key="i">
                    <td class="fw-semibold">{{ l.designation }}</td>
                    <td><span class="badge bg-secondary bg-opacity-10 text-secondary fw-semibold">{{ l.categorie }}</span></td>
                    <td class="text-center fw-bold text-primary">{{ l.quantite }}</td>
                    <td class="text-end font-monospaced">{{ l.prixUnitaireHT.toFixed(3) }} DT</td>
                    <td class="text-center">{{ l.tva }}%</td>
                    <td class="text-end fw-bold text-success font-monospaced">{{ l.prixTotalTTC.toFixed(3) }} DT</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row justify-content-end">
            <div class="col-md-6">
              <div class="card border-0 bg-dark text-white p-3 shadow-sm rounded-3">
                <div class="d-flex justify-content-between mb-2">
                  <span class="text-white-50">Total HT :</span>
                  <strong class="font-monospaced">{{ facture.montantTotalHT.toFixed(3) }} DT</strong>
                </div>
                <div class="d-flex justify-content-between mb-2">
                  <span class="text-white-50">Total TVA :</span>
                  <strong class="font-monospaced">{{ facture.montantTotalTVA.toFixed(3) }} DT</strong>
                </div>
                <hr class="my-2 border-secondary" />
                <div class="d-flex justify-content-between fs-5 fw-bold text-success">
                  <span>Total TTC :</span>
                  <span class="font-monospaced">{{ facture.montantTotalTTC.toFixed(3) }} DT</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="facture.pieceJointe" class="mt-4 pt-3 border-top">
            <h6 class="fw-bold mb-2"><i class="fas fa-paperclip me-2 text-primary"></i>Pièce Jointe / Facture Scannée</h6>
            <a :href="facture.pieceJointe" target="_blank" class="btn btn-sm btn-outline-primary fw-semibold rounded-2">
              <i class="fas fa-file-download me-1"></i>Télécharger le document joint
            </a>
          </div>
        </div>

        <div class="modal-footer bg-white border-top-0 px-4 pb-4">
          <button type="button" class="btn btn-secondary px-4 rounded-3" @click="closeModal">Fermer</button>
          <button type="button" class="btn btn-primary px-4 rounded-3 fw-bold" @click="printInvoice">
            <i class="fas fa-print me-2"></i>Imprimer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FactureAchatDetailModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    facture: {
      type: Object,
      default: null
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleDateString('fr-FR');
    },
    printInvoice() {
      window.print();
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  opacity: 0.5;
}
.font-monospaced {
  font-family: 'JetBrains Mono', monospace;
}
</style>
